<h3 class="text--center mb-2">Why get protected?</h3>
<ul>
  <dgx-cms-dynamic-component-outlet area="why_get_protected">
  </dgx-cms-dynamic-component-outlet>
</ul>
